import {Fragment} from 'react';

import {ValueReplacesService as Service} from './ValueReplacesService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const typeIn = 1;
  const header = 'Giá trị thay thế';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'fieldName', header: 'Trường dữ liệu', minWidth: 250, matchMode: 'contains'},
      {field: 'value', header: 'Giá trị', width: 200, matchMode: 'contains'},
      {field: 'replace', header: 'Giá trị thay thế', width: 200, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.type = typeIn;
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'fieldName', header: 'Trường dữ liệu', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'value', header: 'Giá trị', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'replace', header: 'Giá trị thay thế', InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      item.type = typeIn;
      return Service.create(item);
    },
    updateItem: (id, item) => {
      item.type = typeIn;
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
